export default {
      id: "ic-vs-after-search-all-black-usage",
      viewBox: "0 0 12 12",
      url: "/" + "images/icons.3.109.2.svg#ic-vs-after-search-all-black-usage",
      toString: function () {
        return this.url;
      }
    }